import { render } from "./TypingIndicator.vue?vue&type=template&id=89de65ae&scoped=true"
import script from "./TypingIndicator.vue?vue&type=script&lang=js"
export * from "./TypingIndicator.vue?vue&type=script&lang=js"

import "./TypingIndicator.vue?vue&type=style&index=0&id=89de65ae&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89de65ae"]])

export default __exports__